export default {
  overviewTitle: 'ConfigParams',
  detailTitle: 'ConfigParam',
  deleteTitle: 'dit ConfigParam',
  url: '/manage/configparams',
  apiUrl: '/configparams/',
  sortBy: ['name_nl'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'manage/configparams',
  quickFilter: {
    text: 'Zoek op name',
    value: 'name_nl',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {
      text: 'Naam',
      value: 'name_nl',
      link: '/manage/configparams/{id}',
      width: '10%'
    },
    {
      text: 'Type',
      value: 'type',
      width: '10%'
    },
    {
      text: 'Waarde',
      value: 'value',
      width: '10%'
    }
  ]
};
